import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EDEDED",
      d: "m5.8 1.333-.508.47.93.864H2.56v.666H6.22l-.929.86.508.474L7.6 3zM1.12.667H4V0H1.12C.724 0 .4.3.4.667v4.666C.4 5.7.724 6 1.12 6H4v-.667H1.12z"
    }, null, -1)
  ])))
}
export default { render: render }